export interface Country {
  country: string;
  country_fi: string;
  country_code: string;
  region: string;
  label?: string;
}

// tslint:disable-next-line: align
export const DEFAULT_COUNTRY: Country = {
  region: 'europe',
  country: 'Finland',
  country_fi: 'Suomi',
  country_code: 'fi'
};
